"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _vuePuzzleVcode = _interopRequireDefault(require("vue-puzzle-vcode"));

var _ = _interopRequireDefault(require("../../assets/img/rePhoto/1.png"));

var _index = require("@/model/login/index");

var _message = require("@/components/dialog/message.js");

var _i18n = require("@/assets/js/i18n");

var _vuex = require("vuex");

var _account = require("@/model/user/account");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//页面内引用插件
var _default = {
  data: function data() {
    return {
      isShow: false,
      // 用来控制显示是否显示图片滑动验证框
      photoHua: 0,
      //图片滑动验证的错误次数
      img1: _.default,
      orderStep: 1,
      account: "",
      bindEmail: false,
      bindMobile: false,
      bindGoogle: false,
      isSubmint: false,
      email: "khreui@qq.com",
      mobile: "123klsjflku3o",
      checkList: [],
      checkRadio: "",
      contact: "",
      submitLoading: false
    };
  },
  components: {
    Vcode: _vuePuzzleVcode.default
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language"
  })), {}, {
    getIsApply: function getIsApply() {
      var isApply = false;

      if (this.checkRadio && this.contact) {
        isApply = true;
        return isApply;
      } else {
        isApply = false;
        return isApply;
      }
    }
  }),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var type;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              type = _this.$route.query.type;

              if (!type) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return _this.getUserInfoV2();

            case 4:
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return _this.getUserInfo();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    routeSplicing: _routeSplicing.default,
    translateTitle: _i18n.translateTitle,
    onFilterContact: function onFilterContact(val) {
      this.contact = val.replace(/[^\a-\z\A-\Z0-9\@\-\.\$]/g, "");
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _JSON$parse, authInfo;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _JSON$parse = JSON.parse(localStorage.getItem("userData")), authInfo = _JSON$parse.authInfo;

                if (authInfo) {
                  _this2.bindEmail = authInfo.open_email == 0 ? false : true;
                  _this2.bindMobile = authInfo.open_mobile == 0 ? false : true;
                  _this2.bindGoogle = authInfo.open_google == 0 ? false : true;

                  if (_this2.bindEmail) {
                    _this2.checkRadio = 1;
                  } else if (_this2.bindMobile) {
                    _this2.checkRadio = 2;
                  } else if (_this2.bindGoogle) {
                    _this2.checkRadio = 3;
                  }
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getUserInfoV2: function getUserInfoV2() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var authInfo;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                authInfo = JSON.parse(sessionStorage.getItem("user_info"));

                if (authInfo) {
                  _this3.bindEmail = authInfo.validate_email == 0 ? false : true;
                  _this3.bindMobile = authInfo.validate_mobile == 0 ? false : true;
                  _this3.bindGoogle = authInfo.validate_google == 0 ? false : true;

                  if (_this3.bindEmail) {
                    _this3.checkRadio = 1;
                  } else if (_this3.bindMobile) {
                    _this3.checkRadio = 2;
                  } else if (_this3.bindGoogle) {
                    _this3.checkRadio = 3;
                  }
                }

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    success: function success() {
      this.orderStep = 2;
      this.isShow = false; // 通过验证后，手动隐藏模态框
    },
    onStartApply: function onStartApply() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var req, _yield$apiSafelyLost, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.submitLoading = true;
                req = {
                  type: _this4.checkRadio,
                  contact: _this4.contact,
                  token: sessionStorage.getItem("topcredit_exchange_t")
                };
                _context4.next = 4;
                return (0, _index.apiSafelyLost)(req);

              case 4:
                _yield$apiSafelyLost = _context4.sent;
                status = _yield$apiSafelyLost.status;
                data = _yield$apiSafelyLost.data;
                _this4.submitLoading = false;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this4.translateTitle("\u63D0\u4EA4\u5B89\u5168\u9879\u4E22\u5931\u6210\u529F"),
                    type: "success",
                    duration: 1200
                  });

                  _this4.$router.push(_this4.routeSplicing(_this4.language, "login"));
                }

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};
exports.default = _default;